//Importações do Node Modules
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Importação da tela de Dados Iniciais PF
import DadosIniciaisPF from './dadosIniciaisPF';

//Importações do store
import {
  changeDadosIniciaisPFValueForm,
  handleChangeDadosIniciaisPFDocumento,
  handleChangeDadosIniciaisPFOrgaoEmissor,
  getListDadosIniciaisPFOrgaoEmissorAction,
  getListDadosIniciaisPFDocumentoAction,
  handleChangeTypeaheadDadosIniciaisPais,
  resetDadosIniciaisPF_NomeGerenteAction,
  getListDadosIniciasPFPaisAction,
  getDadosIniciaisExisteCpfAction,
  getDadosIniciaisPFGerenteAction,
  setIdDDIPaisDadosIniciaisPF
} from '../../store/dadosIniciaisPF/actions';

import {configuracaoDdi} from '../../store/ddi/actions';


//Get Ingformações do State do Reducer
const mapStateToProps = (state, nextState) => ({
  dadosIniciaisPF: state.dadosIniciaisPFReducer,
  tipoCadastro: state.tipoCadastroReducer,
  ddiReducer: state.ddiReducer,
});

//Ações efetuadas na action
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeDadosIniciaisPFValueForm,
    handleChangeDadosIniciaisPFDocumento,
    handleChangeDadosIniciaisPFOrgaoEmissor,
    getListDadosIniciaisPFOrgaoEmissorAction,
    getListDadosIniciaisPFDocumentoAction,
    resetDadosIniciaisPF_NomeGerenteAction,
    getListDadosIniciasPFPaisAction,
    handleChangeTypeaheadDadosIniciaisPais,
    getDadosIniciaisExisteCpfAction,
    getDadosIniciaisPFGerenteAction,
    setIdDDIPaisDadosIniciaisPF,
    configuracaoDdi
  }, dispatch);

//Exportação para o Dados Iniciais PF e Reducer
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DadosIniciaisPF);